const ServicesItem = [
    {
        image: require("../assets/web-development.jpg"), 
        heading: "Web Development", 
        shortDescription: "Our website development company partners with clients across Pakistan and around the globe. A website serves as the cornerstone of a business's online presence. A well-designed site not only enhances visibility but also drives customer acquisition and retention. If you're aiming to accelerate growth and boost revenue, collaborating with our website design agency will empower you to achieve your goals.", // Short description
        buttonText: "Contact Us", 
        slug: "web-development",
    },
    {
        image: require("../assets/ai-cover-min.jpg"),
        heading: "Artificial Intelligence",
        shortDescription: "Revolutionize your business with our cutting-edge AI solutions, designed to enhance decision-making, lower operational costs, and elevate customer experiences. Leveraging advanced AI technology, we drive your business toward success. Our goal is to equip companies like yours with innovative AI-driven strategies that improve efficiency, scale operations, and maximize productivity.",
        buttonText: "Contact Us",
        slug: "artificial",
    },
    {
        image: require("../assets/mobile-app-dev-min.jpg"),
        heading: "Mobile Apps",
        shortDescription: "Enhance your digital strategy and unlock the full potential of the mobile era with a dedicated mobile application. It opens new distribution channels for your business while boosting brand visibility, fostering customer loyalty, promoting products and services, and streamlining business processes. A tailored app empowers your company to thrive in today's digital landscape.",
        buttonText: "Contact Us",
        slug: "mobile-app"
    },
    {
        image: require("../assets/graphic-designing-min.jpg"),
        heading: "Graphic Designing",
        shortDescription: "A distinctive visual identity that helps you stand out, capture attention, and shine in a competitive market—delivering results that surpass expectations. We believe design goes beyond aesthetics; it should primarily serve functionality. Elexoft specializes in crafting and evolving brand identities that shape the future of your projects.",
        buttonText: "Contact Us",
        slug: "graphic-designing"
    },
   
    {
        image: require("../assets/crm2.jpg"),
        heading: "CRM Softwares",
        shortDescription: "In today's business landscape, CRM plays a vital role in managing a company's interactions with potential clients. As Pakistan's leading CRM software and website development company, we take pride in our team of highly skilled CRM developers. Our CRM solutions leverage advanced data analysis of both current and past clients to refine business strategies and strengthen relationships, with a core focus on customer retention. Ultimately, this approach drives increased sales and sustainable growth.",
        buttonText: "Contact Us",
        slug: "web-development",
    },
    {
        image: require("../assets/devops-cover1-min.jpg"),
        heading: "DevOps",
        shortDescription: "We revolutionize your business with advanced DevOps practices aimed at boosting efficiency, scalability, and productivity. Our DevOps solutions streamline your software delivery pipeline while promoting a culture of innovation and collaboration within your development team. Want to maximize resources and cut costs? Elexoft Technologies seamlessly bridges the gap between development and operations, ensuring reliable and consistent application services.",
        buttonText: "Contact Us",
        slug: "dev-ops",
    },
    {
        image: require("../assets/iphone-app-development-min.jpg"),
        heading: "iOS Apps",
        shortDescription: "With a vast global community of iPhone users, we specialize in designing and developing native iOS applications that seamlessly adapt to various screen sizes across iPhones and iPads. Our goal is to create an app that stands out on the international stage, driving success for your organization. The App Store serves as Apple's official platform, enabling developers to distribute their apps to users worldwide.",
        buttonText: "Contact Us",
        slug: "mobile-app"
    },
    {
        image: require("../assets/Android-app-development.jpg"),
        heading: "Android Apps",
        shortDescription: "In a remarkably short time, we deliver groundbreaking Android applications that enhance user convenience for the vast Android community. Simply put, we are your go-to solution for all Android development needs. These apps are transforming our lives, reflecting how we continuously adapt to evolving technology and embrace modern living.",
        buttonText: "Contact Us",
        slug: "mobile-app"
    },
    {
        image: require("../assets/business-devlopment.jpeg"),
        heading: "Business-devlopment",
        shortDescription: "",
        buttonText: "Contact Us",
        slug: "business-devlopment"
    },
];

export default ServicesItem;
